import { MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "É possível pagar menos impostos na partilha de bens?",
    a: "Sim. Uma partilha estruturada com planejamento tributário pode reduzir significativamente o ITCMD sobre excedente de meação e o Imposto de Renda sobre ganho de capital. A escolha de quais bens cada parte recebe, o momento da partilha e a forma de escrituração mudam completamente a conta final. Fazemos essa análise antes de qualquer acordo.",
  },
  {
    q: "Como vocês localizam bens que a outra parte escondeu?",
    a: "Utilizamos investigação patrimonial técnica: cruzamento de declarações, movimentações societárias, registros de imóveis, medidas judiciais específicas (como o sistema SISBAJUD, via processo) e análise de padrões de renda. Bens omitidos podem ser partilhados posteriormente, mesmo após o divórcio.",
  },
  {
    q: "O atendimento 100% online é seguro e tem a mesma validade?",
    a: "Totalmente. Advogados podem atuar em todo o território nacional, e o atendimento por videochamada tem a mesma validade e sigilo profissional do presencial. Utilizamos canais criptografados e assinatura eletrônica de documentos. Você recebe acompanhamento completo sem sair de casa — em qualquer cidade do Brasil.",
  },
  {
    q: "Posso proteger meu patrimônio mesmo já estando em processo de divórcio?",
    a: "Na maioria dos casos, sim. Mesmo com processo em andamento, ainda há espaço para estratégia: contestação de avaliações, revisão de partilha proposta, medidas de proteção de liquidez e renegociação de acordos. Quanto antes você agir, maiores as opções — por isso a urgência.",
  },
  {
    q: "Meu caso envolve empresa e sociedades. Vocês atendem essa complexidade?",
    a: "É exatamente o nosso foco. Divórcios que envolvem quotas societárias, holdings, participações empresariais e patrimônio misto exigem atuação integrada entre direito de família, empresarial e tributário. Estruturamos a partilha sem comprometer a operação e o valor da empresa.",
  },
  {
    q: "Quanto custa uma consulta e como funciona o primeiro contato?",
    a: "O primeiro contato é pelo WhatsApp, de forma confidencial e sem compromisso: você descreve brevemente a situação e avaliamos se podemos ajudar. Em seguida, agendamos uma consulta estratégica — por videochamada ou presencial em Naviraí/MS — onde desenhamos o mapa do seu caso.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-[#0B1320]">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Perguntas frequentes"
        title="O que todo cliente pergunta antes de proteger o patrimônio"
        align="center"
      />

      <Reveal delay={0.15} className="mt-12">
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-amber-500/15 bg-[#111C2E] rounded-xl px-6 sm:px-7 data-[state=open]:border-amber-400/40 transition-colors duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-base sm:text-lg font-medium text-slate-100 hover:text-amber-200 hover:no-underline py-5 [&[data-state=open]>svg]:text-amber-400"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.2} className="mt-10 text-center">
        <p className="text-sm text-slate-500 mb-5">Sua dúvida não está aqui?</p>
        <a
          href={waLink(WA_MESSAGES.faq)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="faq-cta-whatsapp"
          className="inline-flex items-center gap-2.5 border border-amber-400/40 text-amber-200 font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-amber-400/10 hover:border-amber-300 transition-colors duration-300"
        >
          <MessageCircle className="w-5 h-5" />
          Perguntar pelo WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
